<template>
  <div>
    <el-form :inline="true" :model="formClass" label-width="90px">
      <el-form-item label="老师:">
        <el-input
          v-model="formClass.name"
          placeholder="请输入老师名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="职务:">
        <el-select v-model="formClass.office" clearable style="width: 175px">
          <el-option
            v-for="item in officeList"
            :key="item.value"
            :label="item.value"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="search" @click="onQuery"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "queryTeacherBar",
  components: {},
  data() {
    return {
      formClass: {
        name: "",
        office:''
      },
      officeList: [
        {
          value: "定级老师",
          label: 1,
        },
        {
          value: "班主任",
          label: 2,
        },
        {
          value: "助教",
          label: 3,
        },
        {
          value: "审核老师",
          label: 4,
        },
      ],
    };
  },
  props: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    onQuery() {
      this.$emit("teacherResult", this.formClass);
      this.$emit("deputyResult", this.formClass);
    },
  },
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// queryTeacherBar.vue?819c9f12